angular.module("app").controller("AddMediaPageController", [
    '$scope',
    'mediaService',
    'errorHandler',
    'logger',
    '$rootScope',
    function ($scope, mediaService, errorHandler, logger, $rootScope) {
        var init;

        (init = function () {
            $scope.image = {
                image: ""
            };
            $scope.draggedImage = undefined;
            $scope.submitData = undefined;
        })();

        $scope.submitAddMediaForm = function () {
            var requestData = {};
            if (!$scope.submitData) {
                requestData.media = angular.copy($scope.image);
            } else {
                requestData.media = angular.copy($scope.submitData);
            }

            mediaService.addImage(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("media.imageCreated");
                        init();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.load = function (dataUrl) {
            $scope.submitData = {image: dataUrl};
        };

        $rootScope.$on("image:uploaded", function () {
            $scope.submitData = undefined;
        })
    }
]);